export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6k-e184ee0ed41eb9292fa2a9192e31eaeb.webp";